import * as v from 'valibot'

export const cookieConsentAppSettingsSchema = v.object({
  version: v.string(),
})

export type CookieConsentAppSettings = v.InferOutput<
  typeof cookieConsentAppSettingsSchema
>
